<template>
  <div class="content-table" style="width:75%;position: relative;overflow: hidden">
    <div class="content-left-row">
      <label class="title">我的购物车</label>
    </div>
    <template>
      <el-table
        :data="data.data"
        height="40rem"
        :header-cell-style="rowStyle"
        ref="multipleTable"
        class="content-row table_scroll"
        style="margin-bottom: 5%;"
        fixed
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="spu_name" align="center" border label="产品信息" min-width="120px">
          <template slot-scope="scope">
            <div style="display: flex;flex-direction: column;text-align: left;">
              <div style="display:flex;font-size:12px;">
                <div style="width:50%;text-align:right;margin-right:5px">{{scope.row.good_name}}</div>
                <div style="font-size: 20px;">|</div>
                <div style="width:48%;margin-left:5px">{{scope.row.good_banane}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="good_spec" border align="center" label="规格" min-width="150px">
          <template slot-scope="scope">
            <div
              style="white-space: pre;text-align:left!important;width:100%;font-family: Courier New;font-size: 13px;"
            >{{scope.row.good_spec}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sale_price" border align="center" label="销售价"></el-table-column>
        <el-table-column prop="good_pcs" border align="center" label="整箱数"></el-table-column>
        <el-table-column prop="qty" border align="center" label="数量" width="150">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.qty"
              @change="handleChange(scope.row.qty,scope.row.id,scope.$index)"
              :min="1"
              size="small"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="amount" border align="center" label="合计金额">
          <template slot-scope="scope">
            <span class="color">￥{{(scope.row.qty*scope.row.sale_price).toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <span class="pointer" @click="del(scope.row)">删除</span>
            <br />
            <el-button round @click="to_collection(scope.row)">移入收藏夹</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pay-div">
        <ul class="cate-menu">
          <li class="menu-li" @click="del_all()">删除选中商品</li>
          <li class="menu-li" @click="clear_all()">清空购物车</li>
          <li class="menu-li">
            已选
            <span class="color">{{multipleSelection.length}}</span>件商品
          </li>
          <li class="menu-li" style="width:15%;">
            <!-- 优惠码:
            <el-input class="discount" v-model="discount"></el-input>-->
          </li>
          <li class="menu-li">
            总价
            <span class="color">{{sums}}</span>
          </li>
          <button class="pay_btn" @click="pay_money">去结算</button>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
// import { debuglog } from "util";
var total_row = [];
export default {
  name: "",
  components: {},

  data() {
    return {
      data: [],
      rowStyle: {
        color: "#000",
        background: "#F1F1F1"
      },
      total: 0,
      pagesize: 10,
      billTime: {
        show: false
      },
      detailes: "",
      row: [],
      sums: "0.00",
      discount: "",
      multipleSelection: [],
      temp_data: []
    };
  },
  mounted() {
    this.view();
  },
  watch: {
    currentPage(oldV, newV) {},
    page: "view",
    pagesize: "view"
  },
  methods: {
    view() {
      this.$axios({
        method: "post",
        url: "/index/cart/index"
        // params: {

        // }
      })
        .then(res => {
          this.data = res.data.data.data;
          this.data.data.forEach((element, i) => {
            if (element.qty > element.stock_num) {
              this.data.data[i].qty = element.stock_num;
            }
          });
          this.temp_data = res.data.data.data;
        })
        .catch(err => {
          this.$message(err);
        });
    },
    handleSelectionChange(row) {
      this.multipleSelection = row;
      var sum_price = 0;
      for (let i = 0; i < row.length; i++) {
        sum_price = row[i].qty * row[i].sale_price + sum_price;
      }
      this.sums = sum_price.toFixed(2);
    },
    edit(row, column, cell, event) {
      // this.billTime.show = true;
      // this.detailes = row.spu_name;
    },
    del(row) {
      var id_arr = [];
      id_arr.push(row.id);
      this.$axios({
        method: "post",
        url: "/index/cart/del_cart",
        params: {
          id: id_arr
        }
      })
        .then(res => {
          this.$message1(res.data.msg);
          this.$axios({
            method: "post",
            url: "/index/cart/get_qty"
          })
            .then(res => {
              this.$store.dispatch("setQty", res.data.data);
              sessionStorage.setItem("qty", this.$store.getters.getcurrentQty);
            })
            .catch(err => {});
          this.view();
        })
        .catch(err => {});
    },
    jump_page(data) {
      // this.$router.push({
      //   path: "/GoodDetail/index",
      //   query: { id: data }
      // });
    },
    del_all() {
      var del_id = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        del_id.push(this.multipleSelection[i].id);
      }
      if (del_id.length == 0) {
        this.$message1("请选中至少一条商品");
        return;
      }
      // return;
      this.$axios({
        method: "post",
        url: "/index/cart/del_cart",
        params: {
          id: del_id
        }
      })
        .then(res => {
          this.$message1(res.data.msg);
          this.$axios({
            method: "post",
            url: "/index/cart/get_qty"
          })
            .then(res => {
              this.$store.dispatch("setQty", res.data.data);
              sessionStorage.setItem("qty", this.$store.getters.getcurrentQty);
            })
            .catch(err => {});
          this.view();
        })
        .catch(err => {});
    },
    clear_all() {
      this.$confirm("此操作将删除清空购物车, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios({
            method: "post",
            url: "/index/cart/clear_cart",
            params: {}
          })
            .then(res => {
              this.$message1(res.data.msg);
              this.$axios({
                method: "post",
                url: "/index/cart/get_qty"
              })
                .then(res => {
                  this.$store.dispatch("setQty", res.data.data);
                  sessionStorage.setItem(
                    "qty",
                    this.$store.getters.getcurrentQty
                  );
                })
                .catch(err => {});
              this.view();
            })
            .catch(err => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleChange(qty, id, i) {
      // alert(qty);
      this.$axios({
        method: "post",
        url: "/index/cart/setqty",
        params: {
          id: id,
          qty: qty
        }
      })
        .then(res => {
          this.$axios({
            method: "post",
            url: "/index/cart/get_qty"
          })
            .then(res => {
              this.$store.dispatch("setQty", res.data.data);
              sessionStorage.setItem("qty", this.$store.getters.getcurrentQty);
            })
            .catch(err => {});
          if (res.data.status == "ok") {
          } else {
            this.$message1(res.data.msg);
            this.data.data[i].qty = this.temp_data.data[i].stock_num;
          }
        })
        .catch(err => {});
    },
    pay_money() {
      if (this.multipleSelection.length == 0) {
        this.$message1("请选择购买商品");
      } else {
        var ids = [];
        var data = [];
        for (var i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
          data.push({
            id: this.multipleSelection[i].id,
            good_id: this.multipleSelection[i].good_itemid,
            qty: this.multipleSelection[i].qty
          });
        }
        sessionStorage.setItem("ids", ids);
        sessionStorage.setItem("data", JSON.stringify(data));

        this.$router.push({
          path: "/Cart/order"
        });
      }
    },
    to_collection(e) {
      var arr = [];
      arr.push(e.good_itemid);
      this.$axios({
        method: "post",
        url: "/index/Collection/create",
        params: {
          id: arr
        }
      })
        .then(res => {
          this.$message1(res.data.msg);
        })
        .catch(err => {});
    },
    refrech() {
      // this.$router.push({ path: this.$router.currentRoute.path });
    }
  }
};
</script>
<style lang="less" scoped>
.title {
  text-align: left;
  margin-bottom: 1%;
  display: block;
}
.settlement_row {
  width: 99%;
  height: 70px;
  // background: red;
  text-align: left;
}
.cate-menu {
  /*width: 65%;*/
  width: 100%;
  /*float: left;*/
  height: 50px;
  line-height: 50px;
  padding-left: 0;
  /*margin-bottom: 2.5%;*/
  border: 1px solid #ebeef5;
  background-color: #ebeef5;
}
.cate-menu li {
  float: left;
  width: auto;
  list-style-type: none;
  margin: 0 3% 0 0;
  // color: #fff;
  height: 100%;
  padding-left: 4%;
  cursor: pointer;
  text-align: left;
}
.pay_btn {
  height: 100%;
  width: 10%;
  background-color: #2d8de4;
  color: #fff;
  border: none;
}
.color {
  color: red;
  font-size: 16px;
}
.good_pic {
  width: 90px;
  height: 100px;
}
.good_datails {
  display: inline-block;
  margin-top: 6%;
  padding-left: 5%;
  font-size: 12px;
}
.good_datails:hover {
  color: #52a6ee;
  cursor: pointer;
}
.discount {
  width: 55%;
}
.table_scroll ::-webkit-scrollbar {
  width: 0px; /*滚动条宽度*/
  height: 5px; /*滚动条高度*/
  background-color: white;
  margin-right: 10px;
}
.pay-div {
  /*position: fixed;*/
  /*bottom: 0px;*/
  position: absolute;
  bottom: -3px;
  text-align: right;
  width: 100%;
  z-index: 111;
}
/*定义滑块 内阴影+圆角*/
.table_scroll ::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px #f5f7fa;
  background-color: rgba(221, 222, 224); /*滚动条的背景颜色*/
}
.el-table__fixed-right-patch {
  width: 0px; /*滚动条宽度*/
}
.el-button.is-round {
  padding: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Cart/index.vue